/* NOPAL LIFE — Auto-enregistrement du Dossier Peau (Phase 1).
   Lecture seule de ce que le diagnostic a déjà écrit dans localStorage (nopal_diagnostics) —
   AUCUNE modification du diagnostic (D6). Dès qu'un diagnostic est terminé (e-mail + prénom +
   consentement déjà recueillis par le formulaire), on enregistre le dossier et on le rattache
   au compte par e-mail, sans clic. Le client retrouve son dossier dans « Mon dossier ».
*/
(function () {
  var BASE = (window.NOPAL_SKIN_BASE || 'https://nopal-skin-service.azbouguerra.workers.dev');
  var SAVED_KEY = 'nopal_autosaved_ts';
  var POLL_MS = 2000;
  var MAX_MS = 15 * 60 * 1000; // arrêt après 15 min sur la page
  var t0 = (new Date()).getTime();

  function validEmail(e) {
    return typeof e === 'string' && e.indexOf('anonyme@') !== 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
  }

  function latestRecord() {
    try {
      var a = JSON.parse(localStorage.getItem('nopal_diagnostics') || '[]');
      return a.length ? a[a.length - 1] : null;
    } catch (e) { return null; }
  }

  function alreadySaved(ts) {
    try { return localStorage.getItem(SAVED_KEY) === String(ts); } catch (e) { return false; }
  }
  function markSaved(ts) {
    try { localStorage.setItem(SAVED_KEY, String(ts)); } catch (e) {}
  }

  function toast(text) {
    try {
      var el = document.createElement('div');
      el.setAttribute('role', 'status');
      el.style.cssText =
        'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:99999;' +
        'background:#2c2a26;color:#fffdf8;font-family:Inter,system-ui,sans-serif;font-size:14px;' +
        'padding:12px 18px;border-radius:12px;box-shadow:0 8px 30px rgba(0,0,0,.25);' +
        'border:1px solid rgba(184,146,63,.5);opacity:0;transition:opacity .35s';
      el.innerHTML = '✓ ' + text + ' &nbsp;<a href="/pages/mon-dossier-peau" style="color:#d8b46a;text-decoration:underline">Voir mon dossier</a>';
      document.body.appendChild(el);
      requestAnimationFrame(function () { el.style.opacity = '1'; });
      setTimeout(function () { el.style.opacity = '0'; setTimeout(function () { el.remove(); }, 400); }, 6000);
    } catch (e) {}
  }

  function post(path, body) {
    return fetch(BASE + path, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  function save(rec) {
    // 1) Assemble + persiste le dossier (anonyme) → renvoie un claim_token.
    post('/v1/dossier/from-profile', { profile: rec }).then(function (d) {
      if (!d || !d.claim_token) { return; }
      // 2) Rattache au compte par e-mail (le consentement RGPD a été coché au diagnostic).
      //    Si la cliente est connectée, on rattache aussi par son id Shopify → visible aussitôt dans « Mon dossier ».
      var cust = window.NOPAL_CUSTOMER || null;
      var payload = { claim_token: d.claim_token, email: rec.email, first_name: rec.firstName || '', consent: true };
      if (cust && cust.id) { payload.shopify_customer_id = cust.id; }
      post('/v1/account/link', payload).then(function (res) {
        if (res && res.linked) {
          markSaved(rec.timestamp);
          toast('Votre dossier a été enregistré');
          try { console.log('[Nopal] Dossier auto-enregistré :', rec.email); } catch (e) {}
        }
      });
    }).catch(function () { /* réseau indisponible — réessai au prochain tick */ });
  }

  function tick() {
    var rec = latestRecord();
    if (rec && validEmail(rec.email) && rec.timestamp && !alreadySaved(rec.timestamp)) {
      save(rec);
    }
  }

  function loop() {
    tick();
    if ((new Date()).getTime() - t0 < MAX_MS) {
      setTimeout(loop, POLL_MS);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loop);
  } else {
    loop();
  }
})();
